// Set actions for dropdown menu on question row
export default function(parentContainer) {

  parentContainer.find('.survey-question-dropdown .toggleDropdown').on('click', function(e) {

    // Prevent default
    e.preventDefault();

    // Open menu
    $(this).closest(".survey-question-dropdown").toggleClass("show");

    // Close other menus
    $('.survey-question-dropdown.show').not($(this).closest(".survey-question-dropdown")).removeClass("show");

  });

  // Remove on click
  $('body').on('click', function (e) {

    // Skip closing dropdowns if the click happened inside an open modal or on its backdrop
    if ($(e.target).closest('.modal').length || $(e.target).hasClass('modal-backdrop')) {
      return;
    }

    // Set dropdown item
    let d = $('.survey-question-dropdown');

    // Remove open class if clicked outside the dropdown
    if ( !d.is(e.target) && d.has(e.target).length === 0) {
      $('.survey-question-dropdown').removeClass('show');
    }

  });

}
